[
  { "label": "Work", "value": "work" },
  { "label": "Personal", "value": "personal" },
  { "label": "Agent", "value": "agent" },
  { "label": "Other", "value": "other" }
]
